import { render, staticRenderFns } from "./ServicesBar.vue?vue&type=template&id=5d3f4538&scoped=true"
import script from "./ServicesBar.vue?vue&type=script&lang=js"
export * from "./ServicesBar.vue?vue&type=script&lang=js"
import style0 from "./ServicesBar.vue?vue&type=style&index=0&id=5d3f4538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3f4538",
  null
  
)

export default component.exports